import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ENVIRONMENT } from 'src/app/constants';
import { IColunaTabela, IContrato } from 'src/app/interfaces';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ListaPaginada } from 'src/app/models';
import { AuthenticationService, ContratoService } from 'src/app/services';
import { Environment } from 'src/app/types';

@Component({
  selector: 'app-listar-contratos',
  templateUrl: './listar-contratos.component.html',
  styleUrls: ['./listar-contratos.component.scss']
})
export class ListarContratosComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  contratoAtivo: boolean = true;

  colunasListagemContratos: IColunaTabela[] = [
    {
      descricao: 'Contrato',
      valor: 'codContrato',
      ativa: true
    },
    {
      descricao: 'Tipo do contrato',
      valor: 'tipoContrato',
      ativa: true
    },
    {
      descricao: 'Status',
      valor: 'statusContrato',
      ativa: true
    },
    {
      descricao: 'Cliente',
      valor: 'nomeCliente',
      ativa: true
    },
    {
      descricao: 'Data de início',
      valor: 'dataInicioContrato',
      ativa: true
    },
    {
      descricao: 'Vencimento',
      valor: 'dataVencimentoContrato',
      ativa: true
    },
    {
      descricao: 'Próximo reajuste',
      valor: 'dataProximoReajusteContrato',
      ativa: true
    },
    {
      descricao: 'Grupo econômico',
      valor: 'nomeGrupoEconomicoCliente',
      ativa: true
    }
  ];

  public get colunasVisiveis(): string[] {
    return this.colunasListagemContratos
      .filter((item) => item.ativa)
      .map((item) => item.valor);
  }

  token: IToken;
  contratos = new ListaPaginada<IContrato>();
  pesquisar = '';

  constructor(
    private authenticationService: AuthenticationService,
    private contratoService: ContratoService,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  obterContratos(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.contratos.paginaAtual = 1;
    }

    this.subscriptions$.add(
      this.contratoService
        .getContratos({
          idUsuario: this.token.id,
          codContrato: this.token.codContrato,
          codGrupoEconomico: this.token.codGrupoEconomico,
          pesquisar: this.pesquisar,
          contratoAtivo: this.contratoAtivo,
          itensPorPagina: this.contratos.itensPorPagina,
          paginaAtual: this.contratos.paginaAtual
        })
        .subscribe({
          next: ({ data }) => {
            this.contratos = data;
          }
        })
    );
  }
  estaAtivoOuInativo() {
    this.contratoAtivo = !this.contratoAtivo;
    this.obterContratos();
  }

  ngOnInit(): void {
    this.token = this.authenticationService.obterToken();
    this.obterContratos();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
